import React from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);
const BtnNuevaActividad = (props) => {
    const handleClick = async () => {
        const { value: formValues } = await MySwal.fire({
            title: 'Nueva Actividad',
            html: (
                <div>
                     <input id="swal-input1" autoComplete='off' className="swal2-input" placeholder="Código Actividad" />
                     <input id="swal-input2" autoComplete='off' className="swal2-input" placeholder="Nombre Actividad" />
                   
                </div>
            ),
            focusConfirm: false,
            preConfirm: () => {
                const COD_Actividad = document.getElementById('swal-input1').value;
                const NOMBRE_Actividad = document.getElementById('swal-input2').value;
                if (!COD_Actividad || !NOMBRE_Actividad) {
                    Swal.showValidationMessage('Ambos campos son requeridos');
                    return false;
                }
                return { CodigoActividad: COD_Actividad, NombreActividad: NOMBRE_Actividad };
            }
        });

        if (formValues) {
            props.AgregarActividad(formValues)
            
        }
    };

    return (
        <div>
            <button onClick={handleClick}>Nueva</button>
        </div>
    );
};

export default BtnNuevaActividad;